export const AccountRouting = [
  {
    path: "/expense/account/list",
    name: "expense-account-list",
    meta: { title: "账号管理" },
    component: () =>
      import(/* webpackChunkName: "expense-account" */ "@/views/expense/account/list/index.vue"),
  },
];
